import * as React from 'react';

import { DesktopFiltersMicrofrontend } from '../DesktopFiltersMicrofrontend/DesktopFiltersMicrofrontend';
import { FiltersSection } from 'shared/components/FiltersSection';
import { EPosition } from 'shared/types/filtersPosition';

interface IFiltersContainerProps {
  isRedesignEnabled?: boolean;
}

export const FiltersContainer: React.FC<IFiltersContainerProps> = ({ isRedesignEnabled = false }) => {
  const [filtersSectionPosition, setFiltersSectionPosition] = React.useState<EPosition>(EPosition.default);
  const updateFiltersHeightCb = React.useRef<() => void | undefined>();

  const setUpdateHeightCb = React.useCallback((cb: () => void) => {
    updateFiltersHeightCb.current = cb;
  }, []);

  return (
    <FiltersSection
      position={filtersSectionPosition}
      setUpdateHeightCb={setUpdateHeightCb}
      onChangePosition={setFiltersSectionPosition}
      isRedesignEnabled={isRedesignEnabled}
    >
      <DesktopFiltersMicrofrontend />
    </FiltersSection>
  );
};
